/*@ngInject*/
const ConfiguredFileRepository = function (baseCachedSharedPromiseRepository) {

    let sharedPromiseCache = {};

    angular.extend(this, baseCachedSharedPromiseRepository);

    this.getCacheName = function () {
        return 'configuredFileCache';
    };

    this.getCacheCapacity = function () {
        return 50;
    };

    this.getSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.find = function (name) {
        const url = '/rest/ConfiguredFile',
            config = {
                params: {
                    name: name
                }
            },
            cacheKey = `name:${name}`;

        return this.get(cacheKey, url, config);
    };
};

angular.module('umCore')
    .service('configuredFileRepository', ConfiguredFileRepository);
